import { NewBookingInput } from "../../../../generated/graphql"

/** Die Felder der abweichenden Rechnungsadresse einer Buchung (Backend: server/invoice/invoiceRecipient.ts). */
export const BILLING_ADDRESS_KEYS = [
    "hasBillingAddress",
    "billingCompanyName",
    "billingFirstname",
    "billingLastname",
    "billingAddition",
    "billingStreet",
    "billingPostCode",
    "billingCity",
] as const

const filled = (value?: string | null) => (value ?? "").trim().length > 0

/** Gewählt, aber unvollständig: Firma oder Nachname sowie Straße, PLZ und Ort sind Pflicht (wie im Backend). */
export const isBillingAddressIncomplete = (bookingData?: NewBookingInput | null): boolean =>
    bookingData?.hasBillingAddress === true &&
    (!(filled(bookingData.billingCompanyName) || filled(bookingData.billingLastname)) ||
        !filled(bookingData.billingStreet) ||
        !filled(bookingData.billingPostCode) ||
        !filled(bookingData.billingCity))

/**
 * Schickt die Rechnungsadresse nur mit, wenn der Schalter im Web Modul an ist und die Kundin sie gewählt hat.
 * Sonst gehen die Felder gar nicht mit (auch kein Rest aus einer früheren Buchung im Speicher).
 */
export const withBillingAddressIfEnabled = (bookingData: NewBookingInput, enabled: boolean): NewBookingInput => {
    if (enabled && bookingData.hasBillingAddress === true) {
        return bookingData
    }
    const withoutBillingAddress: NewBookingInput = { ...bookingData }

    BILLING_ADDRESS_KEYS.forEach((key) => delete withoutBillingAddress[key])

    return withoutBillingAddress
}
